/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'play-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zM8 13.5v-7a.5.5 0 01.8-.4l4.667 3.5a.5.5 0 010 .8L8.8 13.9a.5.5 0 01-.8-.4z" id="svgicon_play-circle_a"/></defs><use _fill="#F4633A" fill-rule="nonzero" xlink:href="#svgicon_play-circle_a" transform="translate(2 2)"/>'
  }
})
